import {
  PROJECT_LIMIT_UPGRADE_POPUP_TYPE,
  STORAGE_LIMIT_UPGRADE_POPUP_TYPE,
  UPGRADE_POPUP_OPENER_REF
} from 'consts'
import { isDraftLimitError, isStorageLimitError } from 'utils/errors'
import { openPricingCardsPopup } from 'utils/pricingCardsPopup'

/**
 * Plan limits reported by the API — the project cap, or a full media library.
 * They are not failures the user can retry, so the generic error popup is the
 * wrong answer: the only way forward is a bigger plan. Each maps to the upgrade
 * popup type whose headline names the limit that was hit.
 *
 * Returns whether the error was a plan limit, so callers can skip their own
 * error popup.
 */
export const handlePlanLimitError = (error: unknown): boolean => {
  if (isDraftLimitError(error)) {
    openPricingCardsPopup({
      type: PROJECT_LIMIT_UPGRADE_POPUP_TYPE,
      openerRef: UPGRADE_POPUP_OPENER_REF
    })

    return true
  }

  if (isStorageLimitError(error)) {
    openPricingCardsPopup({
      type: STORAGE_LIMIT_UPGRADE_POPUP_TYPE,
      openerRef: UPGRADE_POPUP_OPENER_REF
    })

    return true
  }

  return false
}
